"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: asideRef,
    isVisible: asideVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [];
  return <section data-section-id="4308" id="direct-answer-block" className="bg-background text-foreground pt-32 md:pt-44 lg:pt-[180px] pb-24 md:pb-32 lg:pb-[140px] px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {}
        <div className="font-mono text-[11px] tracking-widest text-muted-foreground mb-16 md:mb-20 lg:mb-24 uppercase">
          / ABOUT / 01 — OUR LEGACY
        </div>

        {}
        <div ref={headlineRef} className={`mb-20 md:mb-28 lg:mb-32 transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-[14vw] md:text-[12vw] lg:text-[140px] leading-[0.95] tracking-tight uppercase">
            <span className="block">We Were</span>
            <span className="block font-serif italic font-normal normal-case tracking-tighter text-primary">
              Engravers First.
            </span>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={narrativeRef} className={`lg:col-span-7 transition-all duration-1000 ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-10 md:space-y-12">
              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Before our facility became a hub for industrial marking, it was a small workshop dedicated to the art of precision engraving. We spent decades mastering the nuances of metal and phenolic, ensuring every character met the highest standards of clarity and durability for critical infrastructure.
              </p>

              {}
              <blockquote className="py-6 md:py-8 border-y border-border">
                <p className="font-default italic text-[28px] md:text-[36px] lg:text-[40px] leading-[1.15] tracking-tight text-primary">
                  <span className="text-foreground/40">&ldquo;</span>
                  We don&rsquo;t just mark surfaces; we define the identity of your equipment.
                  <span className="text-foreground/40">&rdquo;</span>
                </p>
              </blockquote>

              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Our commitment to quality didn&rsquo;t fade with time—it evolved. What began as manual pantograph work transformed into a high-tech operation utilizing advanced laser systems, CNC routing, and direct part marking technologies to serve the most demanding industries in the country.
              </p>

              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Today, we operate as a premier industrial marking partner, providing custom solutions for electrical contractors, panel builders, and OEMs. From arc flash labels to complex submittal packages, we ensure your projects are compliant, professional, and built to last.
              </p>
            </div>
          </div>

          {}
          <div ref={asideRef} className={`lg:col-span-4 lg:col-start-9 lg:mt-24 transition-all duration-1000 delay-200 ${asideVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              {}
              <div className="relative w-full overflow-hidden shadow-lg rounded-lg" style={{
              aspectRatio: "3 / 4"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_facility.png-wvc-sizes" alt="Industrial engraving facility" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale" />
              </div>

              {}
              <div className="font-mono text-[11px] tracking-widest text-muted-foreground uppercase">— MASTER ENGRAVER, 2026</div>

              {}
              <div className="h-px bg-border w-full" />

              {}
              <div className="font-mono text-[11px] md:text-xs tracking-widest text-foreground/80 uppercase flex flex-wrap gap-x-2 gap-y-1 leading-relaxed">
                {dataPoints.map((point, i) => <span key={i} data-index={i} className="inline-flex items-center">EST. </span>)}
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 lg:mt-40 flex items-center gap-6">
          <div className="h-px flex-1 bg-border" />
          <div className="font-mono text-[11px] tracking-widest text-muted-foreground uppercase whitespace-nowrap">
            / Continued — Our Capabilities
          </div>
        </div>
      </div>
    </section>;
}